import Config from "./Config";

export interface CardRating {
	login: string;
	socialRating: number;
	swagScore: number;
}

export default class SocialRatingApi {
	public static async fetchRating(login: string, channelLogin: string): Promise<CardRating | null> {
		try {
			const url = `${Config.instance.API_PATH}/socialrating/ratings/${encodeURIComponent(channelLogin)}/${encodeURIComponent(login)}`;
			const res = await fetch(url);
			if (!res.ok) return null;
			const data = await res.json();
			if (data.success === false) return null;
			return {
				login: data.data.viewer.login,
				socialRating: data.data.social_score,
				swagScore: data.data.swag_score,
			};
		} catch (e) {
			console.error("SocialRatingApi fetchRating error:", e);
			return null;
		}
	}
}
